// Bluetooth SIG assigned numbers for the Heart Rate Service.
// Spec: Heart Rate Service v1.0.
//
// Used directly by Web Bluetooth filters and getCharacteristic() calls.

export const HEART_RATE_SERVICE_UUID = 0x180d;
export const HEART_RATE_MEASUREMENT_UUID = 0x2a37;
export const BODY_SENSOR_LOCATION_UUID = 0x2a38;
